import { Skeleton } from '@/components/ui/skeleton';

/** Заглушка на время загрузки кода страницы */
export function PageLoader() {
  return (
    <div className="space-y-6" role="status" aria-label="Загрузка страницы">
      <div className="space-y-2">
        <Skeleton className="h-7 w-56" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-28 rounded-xl" />
        ))}
      </div>
      <Skeleton className="h-80 rounded-xl" />
    </div>
  );
}
